// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3wY2q","subheader":"ReorderModal_subheader__3vIEg","listWrap":"ReorderModal_listWrap__2FHKc"};